import ProfileNav from "./profile-nav"
import './css_files/brand.css'
import { ProfileSocialFriendsCard } from "./profile-social-friends-card"
import { ProfileNavSidePane } from "./profile-nav-side-pane"


export const ProfileSocials = () => {

    const friends  = ["African Bully Registry", "Yaw Twumasi Otuo ", "Divine Quansah"]
    const displayFriends = () => {
        return friends.map((friend) => {
           return <ProfileSocialFriendsCard friend={friend} />
        })
    }
    return (

        <div className='container-fluid'>
            <ProfileNav />
           <div className="container">
                <div className="row align-items-center justify-content-center">
                    <div className="col-md-3 py-5 ">
                        <p><span className="brand-yellow-font pr-3">12</span > Followers</p>
                    </div>
                    <div className="col-md-3  py-5">
                        <p><span className="brand-yellow-font pr-3">12</span > Posts</p>
    
                    </div>
                    <div className="col-md-3 py-5">
                        <p><span className="brand-yellow-font pr-3">12</span > Followers</p>
    
                    </div>
                </div>
    
                <div className="row align-items-start justify-content-center mx-3">
                    <div className="col-md-6 py-5 brand-yellow-border-half  brand-yellow-box-shadow ">
                        <div className="py-5 ">
                                <p className="py-5 my-5"><span className="brand-yellow-font pr-3">0</span > advertissements</p>
    
                        </div>
                    </div>
                    <div className="col-md-6 justify-content-start " >
                        <div className="py-1 px-3 w-100">
                            {displayFriends()}
                        </div>
                        <div className="py-5 brand-yellow-border-half brand-yellow-box-shadow mt-3 w-100">
                            <div className="pt-5"></div>
                            <p><span className="brand-yellow-font pr-3">0 </span >Messages</p>
                        </div>
                    </div>
                </div>
           </div >
        </div>
    )
}